import { render, staticRenderFns } from "./NotificationStack.vue?vue&type=template&id=078a7d85&scoped=true"
import script from "./NotificationStack.vue?vue&type=script&lang=ts"
export * from "./NotificationStack.vue?vue&type=script&lang=ts"
import style0 from "./NotificationStack.vue?vue&type=style&index=0&id=078a7d85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078a7d85",
  null
  
)

export default component.exports